import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState: boolean = false;

const infoSlice = createSlice({
    name: 'info',
    initialState,
    reducers: {
        infoOn: (state) => {
            state = true;
            return state;
        },
        infoOff: (state) => {
            state = false;
            return state;
        },
    },
});

export const { infoOn, infoOff } = infoSlice.actions;
export default infoSlice.reducer;
export const selectInfo = (state: RootState) => state.info;